export enum ROLES {
  ADMIN = 'Administrador',
  USER = 'Usuario',
}